import * as React from "react";
import { ITriggerManualJob } from "../../../redux/types/ITriggerManualJob";
import { BATCH_CONSOLIDATION_JOB_TYPE, CREATED_FROM_KEY, CREATED_TO_KEY, CWR_GENERATION_JOB_TYPE } from "../../Consts";
import { JOB_CREATED_VIEW, LOOKUP_PRODUCTCODE_TYPE, LOOKUP_PRODUCTSOURCE, LOOKUP_WORKSOURCE, SCHEDULE } from "../../../repertoire/Consts";
import { triggerManualJob, upsertScheduledJobAsync, } from "../../../redux/thunks/HomeThunks";
import SizedDateDataInput from "../../../repertoire/components/dateDataInput/DateDataInput";
import ActionButton from "../../../repertoire/components/actionButton/ActionButton";
import { Dropdown, IDropdownOption } from "office-ui-fabric-react/lib/Dropdown";
import { ILookupDictionary } from "../../../lookup/types/ILookupDictionary";
import TextDataInput from "../../../repertoire/components/textDataInput/TextDataInput";
import { Checkbox } from "office-ui-fabric-react/lib/Checkbox";
import { showModal } from "../../../redux/reducers/ModalReducer";
import { MessageBanner, MessageType } from "../../../repertoire/components/messageBanner/MessageBanner";

export interface BatchConsolidationParametersProps {
    triggerManualJob: typeof triggerManualJob;
    createNewJob: any;
    setManualJobParameters: (parameters: ITriggerManualJob) => void;
    lookupValues: ILookupDictionary;
    upsertScheduledJobAsync: typeof upsertScheduledJobAsync;
    showModal: (
        modalContent: string,
        modalComponentInstance: string,
        modalProps: any,
        displayModalCloseButton: boolean,
        title: string
    ) => void;
    scheduledJobSet?: (value: boolean) => void;
    resetMessageBanner?: () => void;
}

interface BatchConsolidationParametersState {
    entityType: string;
    productType: string[];
    productSources: string[];
    workSources: string[];
    createdFrom: string;
    createdTo: string;
    generalError: string[];
    schedule: string;
    runMatching: boolean;
    runPosting: boolean;
    scheduledValue :string;
    scheduleJobSet: boolean;
    scheduleError?: string;
}

export class BatchConsolidationParameters extends React.Component<
    BatchConsolidationParametersProps,
    BatchConsolidationParametersState
> {
    constructor(props: BatchConsolidationParametersProps) {
        super(props);
        this.state = {
            entityType: '',
            productType: [],
            productSources: [],
            workSources: [],
            createdFrom: '',
            createdTo: '',
            generalError: [],
            schedule: '',
            runMatching: false,
            runPosting: false,
            scheduledValue :'',
            scheduleJobSet: false,
            scheduleError: ''
        };
    }

    isValidCron = (cron) => {
        const parts = cron.trim().split(/\s+/);
        if (parts.length !== 5 && parts.length !== 6) return false;

        const validators = [
            { name: 'second', regex: /^(\*|([0-5]?\d)(\/\d+)?|\d+(,\d+)*|\*\/\d+)$/ }, // optional
            { name: 'minute', regex: /^(\*|([0-5]?\d)(\/\d+)?|\d+(,\d+)*|\*\/\d+)$/ },
            { name: 'hour', regex: /^(\*|([01]?\d|2[0-3])(\/\d+)?|\d+(,\d+)*|\*\/\d+)$/ },
            { name: 'dayOfMonth', regex: /^(\*|([1-9]|[12]\d|3[01])(\/\d+)?|\d+(,\d+)*|\*\/\d+)$/ },
            { name: 'month', regex: /^(\*|(1[0-2]|0?[1-9])(\/\d+)?|\d+(,\d+)*|\*\/\d+)$/ },
            { name: 'dayOfWeek', regex: /^(\*|[0-6](\/\d+)?|\d+(,\d+)*|\*\/\d+)$/ }
        ];

        const offset = parts.length === 5 ? 1 : 0;

        return parts.every((part, i) => validators[i + offset].regex.test(part));
    }

    onClick = () => {
        if (this.setParamsandTriggerJob()) {
            const { createNewJob, scheduledJobSet } = this.props;
            scheduledJobSet(true);
            createNewJob();
        }
    }

    handleFromDateChange = (value: string | number | boolean, fieldname: string) => {
        this.setState({
            createdFrom: value as string
        });
    }

    handleToDateChange = (value: string | number | boolean, fieldname: string) => {
        this.setState({
            createdTo: value as string
        });
    }

    handleWorkSourceOptionChange = (event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption, index?: number) => {
        const { workSources } = this.state;

        if (option?.selected) {
            workSources.push(option.data);
            this.setState({ workSources });
        } else {
            const updatedOptions = workSources.filter(opt => opt !== option.data);
            this.setState({ workSources: updatedOptions });
        }
    };

    handleProductSourceOptionChange = (event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption, index?: number) => {
        const { productSources } = this.state;

        if (option?.selected) {
            productSources.push(option.data);
            this.setState({ productSources });
        } else {
            const updatedOptions = productSources.filter(opt => opt !== option.data);
            this.setState({ productSources: updatedOptions });
        }
    };

    handleEntityChange = (event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption, index?: number) => {
        this.setState({
            entityType: option.data as string
        });
    }

    handleRunMatchingChange = (ev: React.FormEvent<HTMLElement>, isChecked: boolean) => {
        this.setState({ runMatching: isChecked });
    }

    handleRunPostingChange = (ev: React.FormEvent<HTMLElement>, isChecked: boolean) => {
        this.setState({ runPosting: isChecked });
    }

    getMultiSelectOptions = (lookupType: string) => {
        const { lookupValues } = this.props;
        if (!lookupValues || !lookupValues[lookupType]) {
            console.warn(`lookupValues or ${lookupType} is undefined`);
            return [];
        }
        var lookups = lookupValues[lookupType].lookups.filter((x) => x.code !== "NULL" && x.code !== null);

        const options = [];

        if (lookups) {
            lookups.map((c) => options.push({
                data: c.code,
                text: c.description,
                key: c.code
            }));
            options.sort((a, b) => a.text.localeCompare(b.text));
        }
        options.unshift({ key: "All", text: "All", data: "*" });
        return options;
    }

    componentDidMount() {

    }

    setParamsandTriggerJob = () => {
        const { setManualJobParameters, triggerManualJob } = this.props;
        const { entityType, productType, productSources, workSources, createdFrom, createdTo, runMatching, runPosting } = this.state;

        if (this.validateFields()) {
            const manualJobParameters: ITriggerManualJob = {
                jobType: BATCH_CONSOLIDATION_JOB_TYPE,
                jobParameters: JSON.stringify({
                    entityType: entityType,
                    productType: productType,
                    productSources: entityType === "PRODUCTS" ? productSources : [],
                    workSources: entityType === "WORKS" ? workSources : [],
                    createdFrom: createdFrom,
                    createdTo: createdTo,
                    runMatching: runMatching,
                    runPosting: runPosting
                }),
            };

            setManualJobParameters(manualJobParameters);
            return triggerManualJob(manualJobParameters);
        } else {
            return false;
        }
    }

    validateFields = () => {
        const { entityType, workSources, productSources, createdFrom, createdTo } = this.state;
        let errorList = [];

        if (entityType === '' || (entityType === "PRODUCTS" && productSources.length === 0) || (entityType === "WORKS" && workSources.length === 0))
            errorList.push('Please fill in all the required fields\n');

        if (createdFrom !== '' && createdTo !== '') {
            if (new Date(createdFrom) > new Date(createdTo))
                errorList.push('Invalid date selection');
        }

        this.setState({ generalError: [...errorList] });

        return (errorList.length === 0);
    };

    dismissAlert = () => {
        this.setState({ generalError: [], scheduleError:'' });
    };

    setWorkSources = (newSources: string[]) => {
        this.setState({ workSources: newSources });
    };

    setProductSources = (newSources: string[]) => {
        this.setState({ productSources: newSources });
    };

    setProductType = (newProductType: string[]) => {
        this.setState({ productType: newProductType });
    };

    setScheduleState = (newSchedule: string) => {
        this.setState({ schedule: newSchedule });
    }

    getEntityTypeState = () => {
        return this.state.entityType;
    }

    getProductSourcesState = () => {
        return this.state.productSources;
    }

    getWorkSourcesState = () => {
        return this.state.workSources;
    }

    getCreatedFrom = () => {
        return this.state.createdFrom;
    }

    getCreatedTo = () => {
        return this.state.createdTo;
    }

    enableSchedule = () => {
        let errorList = []
        let entityType = this.getEntityTypeState();
        let productSources = this.getProductSourcesState();
        let workSources = this.getWorkSourcesState();
        let createdFrom = this.getCreatedFrom();
        let createdTo = this.getCreatedTo();

        if (entityType === '' || (entityType === "PRODUCTS" && productSources.length === 0) || (entityType === "WORKS" && workSources.length === 0))
            return true;

        if (createdFrom !== '' && createdTo !== '') {
            if (new Date(createdFrom) > new Date(createdTo))
                return true;
        }
        return false;
    }

    setSchedule = () => {
        const { upsertScheduledJobAsync, createNewJob, showModal } = this.props;
        const { entityType, productType, productSources, workSources, createdFrom, createdTo, schedule } = this.state;

        let scheduledJob;
        const valid = this.isValidCron(schedule);

        if (this.validateFields() && valid) {
            if (entityType === "PRODUCTS") {
                scheduledJob = {
                    cronSchedule: schedule,
                    errorList: [],
                    lastRunDate: null,
                    parameters: JSON.stringify({
                        entityType: entityType,
                        productType: productType,
                        productSources: entityType === "PRODUCTS" ? productSources : [],
                        createdFrom: createdFrom,
                        createdTo: createdTo
                    }),
                    type: BATCH_CONSOLIDATION_JOB_TYPE
                }
            } else {
                scheduledJob = {
                    cronSchedule: schedule,
                    errorList: [],
                    lastRunDate: null,
                    parameters: JSON.stringify({
                        entityType: entityType,
                        workSources: entityType === "WORKS" ? workSources : [],
                        createdFrom: createdFrom,
                        createdTo: createdTo
                    }),
                    type: BATCH_CONSOLIDATION_JOB_TYPE
                }
            }
            if (scheduledJob) {
                this.setState({ scheduleError: '' });
                this.props.scheduledJobSet(true);
                upsertScheduledJobAsync(scheduledJob);
                createNewJob();
                this.setParamsandTriggerJob()
            }
        } else {
            this.setState({ scheduleError : 'Please enter a valid Schedule expression.' });
        }
    }

    handleScheduleChange = (value: string | boolean | number, fieldname: string) => {
        this.setScheduleState(value.toString());
        this.setState({ generalError: [] });
    }
    
    handleChangeMultiSelect = (lookupType: string, option?: IDropdownOption) => {
        const setNewOptions = (lookupType, newOptions) => {
            let allOptions = this.getMultiSelectOptions(lookupType).map(x => x.key);
            allOptions = allOptions.filter(x => x !== "All");

            if (option.key == "All") {
                if (newOptions.length == allOptions.length) {
                    newOptions = [];
                }
                else {
                    newOptions = [];
                    newOptions.push(...allOptions);
                }
            }
            else if (option.selected) {
                newOptions.push(option.key.toString());
            }
            else {
                newOptions.splice(newOptions.indexOf(option.key.toString()), 1);
            }
            return newOptions;
        }

        const { productSources, workSources, productType } = this.state;

        if (lookupType === LOOKUP_PRODUCTCODE_TYPE) {
            let newProductTypeOptions = productType;
            newProductTypeOptions = setNewOptions(LOOKUP_PRODUCTCODE_TYPE, newProductTypeOptions);
            this.setProductType([...newProductTypeOptions]);
        }
        else if (lookupType === LOOKUP_PRODUCTSOURCE) {
            let newSourceOptions = productSources;
            newSourceOptions = setNewOptions(LOOKUP_PRODUCTSOURCE, newSourceOptions);
            this.setProductSources([...newSourceOptions]);
        }
        else if (lookupType === LOOKUP_WORKSOURCE) {
            let newSourceOptions = workSources;
            newSourceOptions = setNewOptions(LOOKUP_WORKSOURCE, newSourceOptions);
            this.setWorkSources([...newSourceOptions]);
        }
    };

    renderEntityOptions = () => {
        let entityOptions = [{
            data: 'PRODUCTS',
            text: 'Products',
            key: '1'
        }, {
            data: 'WORKS',
            text: 'Works',
            key: '2'
        }];

        return entityOptions;
    }

    renderDates = () => {
        const { createdFrom, createdTo, runMatching, runPosting } = this.state;
        return (<div className="form-group col-md-6 col-sm-6 col-xs-12">
            <div style={{ display: 'flex', gap: '20px' }}>
                <SizedDateDataInput
                    label={CREATED_FROM_KEY}
                    fieldName={CREATED_FROM_KEY}
                    value={createdFrom}
                    changeData={this.handleFromDateChange}
                    readOnly={false}
                    isHidden={false}
                />
                <SizedDateDataInput
                    label={CREATED_TO_KEY}
                    fieldName={CREATED_TO_KEY}
                    value={createdTo}
                    changeData={this.handleToDateChange}
                    readOnly={false}
                    isHidden={false}
                />
            </div>
            <div style={{ display: 'flex', gap: '20px', marginTop: '10px', marginLeft: '18px' }}>
                <Checkbox
                    label="Run Matching"
                    checked={runMatching}
                    onChange={this.handleRunMatchingChange}
                />
                <Checkbox
                    label="Run Posting"
                    checked={runPosting}
                    onChange={this.handleRunPostingChange}
                />
            </div>
        </div>
        )
    }

    render() {
        const { entityType, productType, workSources, productSources, createdFrom, createdTo, generalError, schedule,scheduleJobSet,scheduleError } = this.state;
        const { resetMessageBanner } = this.props;

        return (
            <>
                {generalError && generalError.length > 0 && (
                    <div className="alert alert-danger alert-dismissible">
                        <span>{generalError}</span>
                        <button type="button" className="close" aria-label="Close" onClick={this.dismissAlert}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                )}
                 
                <div className="row">
                    <div className="form-group col-md-6 col-sm-6 col-xs-12">
                        <label>Entity Type</label>
                        <Dropdown
                            options={this.renderEntityOptions()}
                            multiSelect={false}
                            onChange={this.handleEntityChange}
                            placeholder={""}
                            disabled={false}
                            required={true}
                        />
                    </div>
                    {entityType === 'PRODUCTS' && (
                        <div>
                            <div className="form-group col-md-6 col-sm-6 col-xs-12">
                                <label>Product Type</label>
                                <Dropdown
                                    selectedKeys={productType}
                                    options={this.getMultiSelectOptions(LOOKUP_PRODUCTCODE_TYPE)}
                                    multiSelect={true}
                                    onChange={(e, o, i) => this.handleChangeMultiSelect(LOOKUP_PRODUCTCODE_TYPE, o)}
                                    placeholder={""}
                                />
                            </div>
                            <div className="form-group col-md-6 col-sm-6 col-xs-12">
                                <label>Sources</label>
                                <Dropdown
                                    selectedKeys={productSources}
                                    options={this.getMultiSelectOptions(LOOKUP_PRODUCTSOURCE)}
                                    multiSelect={true}
                                    onChange={(e, o, i) => this.handleChangeMultiSelect(LOOKUP_PRODUCTSOURCE, o)}
                                    placeholder={""}
                                    required={true}
                                />
                            </div>
                            {this.renderDates()}
                        </div>
                    )}
                    {entityType === 'WORKS' && (
                        <div>
                            <div className="form-group col-md-6 col-sm-6 col-xs-12">
                                <label>Sources</label>
                                <Dropdown
                                    selectedKeys={workSources}
                                    options={this.getMultiSelectOptions(LOOKUP_WORKSOURCE)}
                                    multiSelect={true}
                                    onChange={(e, o, i) => this.handleChangeMultiSelect(LOOKUP_WORKSOURCE, o)}
                                    placeholder={""}
                                    required={true}
                                />
                            </div>
                            <div className="row">
                                {this.renderDates()}
                               

                            </div>
                        </div>
                    )}
                </div>
                <div className="row">
                    <div className="form-group fullWidth col-md-4 col-sm-6 col-xs-12 flexRow flexJustifyContentLeft">
                        <TextDataInput
                            label={SCHEDULE}
                            fieldName={SCHEDULE}
                            changeData={this.handleScheduleChange}
                            value={schedule}
                            isHidden={false}
                            isMandatory={false}
                            readOnly={this.enableSchedule()}
                        />
                        <div className="flexRow flexJustifyContentCenter form-group col-md-2 col-sm-4 col-xs-12" style={{ marginTop: "13px" }}>
                            <ActionButton buttonText={"Set"} buttonAction={this.setSchedule} disabled={this.enableSchedule()} />
                        </div>
                    </div>
                </div>
                {scheduleError && scheduleError.length > 0 && (
                    <div className="alert alert-danger alert-dismissible">
                        <span>{scheduleError}</span>
                        <button type="button" className="close" aria-label="Close" onClick={this.dismissAlert}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                )}
                <div className="fullWidth flexRow flexJustifyContentRight">
                    <div className="form-group col-md-2 col-sm-2 col-xs-12">
                        <ActionButton buttonText={"Create Manual Job"} buttonAction={() => this.onClick()} />
                    </div>
                </div>
            </>
        );
    }
}

export default BatchConsolidationParameters;